import React from 'react';
import cn from 'classnames';

import styles from './style.scss';

interface Props extends React.HTMLAttributes<HTMLUListElement> {
  children: React.ReactNode;
  isGrid: boolean;
}

const DefaultList = ({ children, isGrid = false, ...restProps }: Props) => (
  <ul
    className={cn(styles.list, { [styles['is-grid']]: isGrid })}
    {...restProps}
  >
    {children}
  </ul>
);

export default DefaultList;
